import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import _defineProperty from "/data/work/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { asyncRoutes, constantRoutes } from '@/router';
import store from '..';
function hasPermission(roles, route) {
  var userAuths = store.getters.auth || roles || [];
  if (route.auth) {
    if (Array.isArray(route.auth)) {
      return route.auth.some(function (x) {
        return userAuths.includes(x);
      });
    } else {
      return userAuths.includes(route.auth);
    }
  } else {
    return true;
  }
}

// 全局唯一：过滤重复路由 name
var uniqueNameSet = new Set();
function filterAsyncRoutes(routes, roles) {
  var res = [];
  var guannanAdminBg = null;

  // guannan 伪超管：只允许访问 admin-bg/admin-info
  var currentUser = JSON.parse(localStorage.getItem('userInfo') || '{}') || {};
  var isGuannan = currentUser.username === 'guannan' || currentUser.account === 'guannan';
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    var permitted = hasPermission(roles, tmp);

    // guannan 特殊处理：保存 admin-bg（仅含 admin-info），最后追加到末尾保证侧栏顺序正确
    if (!permitted && isGuannan && tmp.path === '/admin-bg') {
      var adminInfoChild = (tmp.children || []).find(function (c) {
        return c.path === '/admin-bg/admin-info';
      });
      if (adminInfoChild) {
        guannanAdminBg = _objectSpread(_objectSpread({}, tmp), {}, {
          redirect: '/admin-bg/admin-info',
          children: [adminInfoChild]
        });
      }
      return; // 暂不插入，待最后追加
    }
    if (permitted) {
      if (tmp.name) {
        if (uniqueNameSet.has(tmp.name)) {
          return;
        }
        uniqueNameSet.add(tmp.name);
      }
      if (tmp.children && tmp.children.length > 0) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });

  // 追加 guannan 的 admin-bg 到末尾，保证侧栏顺序在其他模块之后
  if (guannanAdminBg) {
    var nameOk = !guannanAdminBg.name || !uniqueNameSet.has(guannanAdminBg.name);
    if (nameOk) {
      if (guannanAdminBg.name) uniqueNameSet.add(guannanAdminBg.name);
      if (guannanAdminBg.children && guannanAdminBg.children.length > 0) {
        guannanAdminBg.children = filterAsyncRoutes(guannanAdminBg.children, roles);
      }
      res.push(guannanAdminBg);
    }
  }
  return res;
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, roles) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      uniqueNameSet.clear();
      var accessedRoutes;
      var auth = store.getters.authRoles;
      if (auth.includes('super')) {
        accessedRoutes = asyncRoutes || [];
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes, roles);
      }
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};